/*
 * JHKCreate — custom.js
 * Clock-based day/night theme engine + supporting utilities
 */

(function() {

/* ══════════════════════════════════════════════════
   DAY / NIGHT THEME ENGINE
   Visitor's local clock: day 6am–8pm, night otherwise.
   No geolocation — the browser never asks for location.
══════════════════════════════════════════════════ */

var manualOverride = null;

function applyTheme(isDay, source) {
  var root  = document.documentElement;
  var icon  = document.getElementById('pill-icon');
  var label = document.getElementById('pill-label');
  var mode  = document.getElementById('pill-mode');
  if (isDay) {
    root.classList.add('jhk-day');
    if (icon)  icon.textContent  = '☀️';
    if (label) label.textContent = 'Day';
  } else {
    root.classList.remove('jhk-day');
    if (icon)  icon.textContent  = '🌙';
    if (label) label.textContent = 'Night';
  }
  if (mode) mode.textContent = source || 'auto';
}

function fallbackHeuristic() {
  var h = new Date().getHours();
  applyTheme(h >= 6 && h < 20, 'clock');
}

window.jhkToggleTheme = function() {
  manualOverride = !document.documentElement.classList.contains('jhk-day');
  applyTheme(manualOverride, 'manual');
};

// Apply on load — zero flash
fallbackHeuristic();

// Re-check every 10 min (handles staying on tab across 6am / 8pm)
setInterval(function() {
  if (manualOverride !== null) return;
  fallbackHeuristic();
}, 10 * 60 * 1000);


/* ══════════════════════════════════════════════════
   CUSTOM CURSOR
══════════════════════════════════════════════════ */

var cur  = document.getElementById('jhk-cursor');
var ring = document.getElementById('jhk-cursor-ring');

if (cur && ring) {
  var mx = -200, my = -200, rx = -200, ry = -200;

  document.addEventListener('mousemove', function(e) {
    mx = e.clientX; my = e.clientY;
  });

  (function cursorLoop() {
    rx += (mx - rx) * 0.13;
    ry += (my - ry) * 0.13;
    cur.style.left  = mx + 'px'; cur.style.top  = my + 'px';
    ring.style.left = rx + 'px'; ring.style.top = ry + 'px';
    requestAnimationFrame(cursorLoop);
  })();

  document.querySelectorAll('a, button, .jhk-service-card, .jhk-pillar, .jhk-blog-card, .jhk-chip, [onclick]').forEach(function(el) {
    el.addEventListener('mouseenter', function() {
      cur.style.width  = '18px'; cur.style.height  = '18px';
      ring.style.width = '54px'; ring.style.height = '54px';
      ring.style.borderColor = 'rgba(0,229,255,.7)';
    });
    el.addEventListener('mouseleave', function() {
      cur.style.width  = '10px'; cur.style.height  = '10px';
      ring.style.width = '36px'; ring.style.height = '36px';
      ring.style.borderColor = 'rgba(0,229,255,.35)';
    });
  });
}


/* ══════════════════════════════════════════════════
   SCROLL REVEAL
══════════════════════════════════════════════════ */

var reveals = document.querySelectorAll('.jhk-reveal');
if (reveals.length && 'IntersectionObserver' in window) {
  var ro = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('jhk-visible');
        ro.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });
  reveals.forEach(function(el) { ro.observe(el); });
}


/* ══════════════════════════════════════════════════
   HERO QUALIFIER
══════════════════════════════════════════════════ */

var jhkQualifierData = {
  new: {
    tag: 'Platform Architecture',
    title: "Let's build something right from the start.",
    body: "We design Shopify storefronts around your business logic, not a template's limitations. Custom themes, bespoke checkout flows, multi-market configuration — built to scale from day one.",
    cta: 'Tell us about your project'
  },
  fix: {
    tag: 'Strategic Consulting',
    title: "We'll find what's holding you back.",
    body: "We audit your entire Shopify ecosystem — theme architecture, app stack, checkout flow, and fulfilment logic — and deliver a clear technical roadmap. Not a sales pitch.",
    cta: 'Book a store audit'
  },
  integrate: {
    tag: 'Custom Features',
    title: 'We engineer the invisible infrastructure.',
    body: "ERP connections, warehouse syncs, payment gateways, third-party APIs. We build the integrations that run flawlessly behind the scenes so your team stops firefighting.",
    cta: 'Describe your integration'
  },
  scale: {
    tag: 'Retained Partnership',
    title: "We stay. That's the difference.",
    body: "Priority support, Shopify version updates, conversion monitoring, and proactive recommendations — because a high-growth store needs a long-term technical partner.",
    cta: 'Ask about retained plans'
  },
  consult: {
    tag: 'Strategic Consulting',
    title: 'An honest conversation costs nothing.',
    body: "Tech stack assessments, migration planning, and architecture decisions for brands that have outgrown their current setup. We advise on the calls that compound over years.",
    cta: 'Start the conversation'
  }
};

window.jhkSelectChip = function(el) {
  document.querySelectorAll('.jhk-chip').forEach(function(c) { c.classList.remove('active'); });
  el.classList.add('active');
  var d = jhkQualifierData[el.dataset.id];
  if (!d) return;
  document.getElementById('jhk-r-tag').textContent    = d.tag;
  document.getElementById('jhk-r-title').textContent  = d.title;
  document.getElementById('jhk-r-body').textContent   = d.body;
  document.getElementById('jhk-r-cta').textContent    = d.cta;
  var wrap = document.getElementById('jhk-result-wrap');
  var card = document.getElementById('jhk-result-card');
  wrap.style.height = '0'; card.style.opacity = '0'; card.style.transform = 'translateY(10px)';
  requestAnimationFrame(function() {
    wrap.style.transition = 'height .38s cubic-bezier(.4,0,.2,1)';
    wrap.style.height = card.scrollHeight + 'px';
    setTimeout(function() {
      card.style.transition = 'opacity .3s ease, transform .3s ease';
      card.style.opacity = '1';
      card.style.transform = 'translateY(0)';
      wrap.style.height = 'auto';
    }, 220);
  });
};


/* ══════════════════════════════════════════════════
   PARTICLES (hero canvas)
══════════════════════════════════════════════════ */

var canvas = document.getElementById('jhk-particles');
if (canvas) {
  var ctx = canvas.getContext('2d');
  var W, H, pts = [];

  function resize() {
    W = canvas.width  = canvas.offsetWidth;
    H = canvas.height = canvas.offsetHeight;
  }
  resize();
  window.addEventListener('resize', function() { resize(); initPts(); });

  function initPts() {
    pts = [];
    var n = Math.min(Math.floor(W * H / 8000), 80);
    for (var i = 0; i < n; i++) {
      pts.push({
        x: Math.random() * W, y: Math.random() * H,
        vx: (Math.random() - .5) * .35, vy: (Math.random() - .5) * .35,
        r: Math.random() * 1.1 + .3,
        a: Math.random() * .45 + .1,
        hue: Math.random() < .6 ? 189 : 82
      });
    }
  }
  initPts();

  function drawPts() {
    ctx.clearRect(0, 0, W, H);
    var isDay = document.documentElement.classList.contains('jhk-day');
    for (var i = 0; i < pts.length; i++) {
      var p = pts[i];
      p.x += p.vx; p.y += p.vy;
      if (p.x < 0) p.x = W; if (p.x > W) p.x = 0;
      if (p.y < 0) p.y = H; if (p.y > H) p.y = 0;
      // Day: blue/green tones; Night: cyan/lime
      var hue = isDay ? (p.hue === 189 ? 210 : 120) : p.hue;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fillStyle = 'hsla(' + hue + ',100%,' + (isDay ? '40' : '70') + '%,' + p.a + ')';
      ctx.fill();
      for (var j = i + 1; j < pts.length; j++) {
        var q = pts[j];
        var dx = p.x - q.x, dy = p.y - q.y, d = Math.sqrt(dx * dx + dy * dy);
        if (d < 85) {
          ctx.beginPath(); ctx.moveTo(p.x, p.y); ctx.lineTo(q.x, q.y);
          ctx.strokeStyle = 'hsla(' + hue + ',100%,' + (isDay ? '40' : '70') + '%,' + ((1 - d / 85) * .1) + ')';
          ctx.lineWidth = .5; ctx.stroke();
        }
      }
    }
    requestAnimationFrame(drawPts);
  }
  drawPts();
}

})();
